/**
 * reCAPTCHA v3 — chargement à la demande, partagé par les formulaires
 * (brevo-form, contact-form, invitation-form, volunteer-form).
 *
 * Le script Google (~350 Ko, plusieurs centaines de ms de calcul sur mobile)
 * n'est plus chargé sur toutes les pages : il part quand le visiteur entre
 * dans un formulaire (preloadRecaptcha, sur focusin), au plus tard à l'envoi
 * (getRecaptchaToken). Importé en relatif, comme slider.js.
 */

let loading = null;

export function preloadRecaptcha( siteKey ) {
	if ( ! siteKey ) return Promise.resolve( null );
	if ( window.grecaptcha?.execute ) return Promise.resolve( window.grecaptcha );

	if ( ! loading ) {
		loading = new Promise( ( resolve ) => {
			const script = document.createElement( 'script' );
			script.src   = `https://www.google.com/recaptcha/api.js?render=${ encodeURIComponent( siteKey ) }`;
			script.async = true;
			script.onload  = () => window.grecaptcha.ready( () => resolve( window.grecaptcha ) );
			script.onerror = () => {
				loading = null;
				resolve( null );
			};
			document.head.appendChild( script );
		} );
	}

	return loading;
}

export function getRecaptchaToken( siteKey, action ) {
	return preloadRecaptcha( siteKey ).then( ( grecaptcha ) => {
		if ( ! grecaptcha ) return '';
		return grecaptcha.execute( siteKey, { action } ).catch( () => '' );
	} );
}
